import { render, staticRenderFns } from "./DropdownCheckboxFKMedicao.vue?vue&type=template&id=591fbf9e"
import script from "./DropdownCheckboxFKMedicao.vue?vue&type=script&lang=js"
export * from "./DropdownCheckboxFKMedicao.vue?vue&type=script&lang=js"
import style0 from "./DropdownCheckboxFKMedicao.vue?vue&type=style&index=0&id=591fbf9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports